module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-components"
  }, [_c('div', {
    staticClass: "plus-minus"
  }, [_c('button', {
    on: {
      "click": _vm.minus
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 10px",
      "font-size": "22px",
      "color": "#5E6D82"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.countNumber) + "\n        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.plus
    }
  }, [_vm._v("+")])]), _vm._v(" "), (_vm.maxCount > 0) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary  btn-big buynow",
    on: {
      "click": _vm.buyNow
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buy_now')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-hollow btn-big add_cart",
    on: {
      "click": _vm.addShopCart
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('add_to_cart')) + "\n        ")])]) : _c('div', [_c('button', {
    staticClass: "btn btn-gray btn-hollow btn-big buynow"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('store_mainpage_out_of_stock')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-gray btn-hollow btn-big add_cart"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('add_to_cart')) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3b21026","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Buy.vue
// module id = 854
// module chunks = 0